// extracted by mini-css-extract-plugin
export default {"default":"PhoneCell_default__RSRpg","notCall":"PhoneCell_notCall__ra-3z","payCall":"PhoneCell_payCall__wHP1r","unavailable":"PhoneCell_unavailable__-mk9m"};